import { Button, ButtonVariation } from '../../../../components/Button';
import Modal from '../../../../components/Modal/Modal';
import { ModalSize } from '../../../../utils';

import './DocumentRemovalConfirmationModal.css';

interface DocumentRemovalConfirmationModalProps {
  fileNames: string[];
  isDeleting: boolean;
  isOpen: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

function DocumentRemovalConfirmationModal({
  fileNames,
  isDeleting,
  isOpen,
  onCancel,
  onConfirm,
}: DocumentRemovalConfirmationModalProps) {
  return (
    <Modal
      className='document-removal-modal-wrapper'
      data-testid='document-removal-confirmation-modal'
      heading='Delete documents that are no longer needed?'
      isOpen={isOpen}
      preventDismiss={isDeleting}
      size={ModalSize.Medium}
      onClose={onCancel}>
      <div className='document-removal-modal'>
        <div className='document-removal-modal__description'>
          <p>
            Changing this answer will delete these documents because they will no longer be relevant to your
            application.
          </p>
          <ul>
            {fileNames.map((fileName, index) => (
              <li key={`${fileName}-${index}`}>{fileName}</li>
            ))}
          </ul>
          <p className='document-removal-modal__follow-up'>
            See the Residency Document section on the Document Upload page for any new files you may need to upload.
          </p>
        </div>
        <div className='document-removal-modal__actions'>
          <Button
            bordered
            isAutoWidth
            disabled={isDeleting}
            type='button'
            variation={ButtonVariation.GHOST}
            onClick={onCancel}>
            Cancel
          </Button>
          <Button
            isAutoWidth
            disabled={isDeleting}
            type='button'
            variation={ButtonVariation.SOLID}
            onClick={onConfirm}>
            {isDeleting ? 'Deleting…' : 'Delete Document and Continue'}
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export default DocumentRemovalConfirmationModal;
